var React = require('react');

function Shield (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"#7088A1","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5","d":"M7.6 16s5.6-2.8 5.6-7V4.1L7.6 2 2 4.1V9c0 4.2 5.6 7 5.6 7z"}));
}

Shield.defaultProps = {"width":"15","height":"18","viewBox":"0 0 15 18"};

module.exports = Shield;

Shield.default = Shield;
